/* unplugin-vue-components disabled */import { render } from "./ai-message.vue?vue&type=template&id=2410daf6&scoped=true"
import script from "./ai-message.vue?vue&type=script&lang=js"
export * from "./ai-message.vue?vue&type=script&lang=js"

import "./ai-message.vue?vue&type=style&index=0&id=2410daf6&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2410daf6"],['__file',"src/components/ai-chat-v2/ai-message.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2410daf6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2410daf6', __exports__)) {
    api.reload('2410daf6', __exports__)
  }
  
  module.hot.accept("./ai-message.vue?vue&type=template&id=2410daf6&scoped=true", () => {
    api.rerender('2410daf6', render)
  })

}


export default __exports__